export default __webpack_public_path__ + "static/media/document.a3b2c61e.svg";